import { classNames } from 'app/functions'
import useDesktopMediaQuery from 'app/hooks/useDesktopMediaQuery'
import React, { FC } from 'react'

const DoubleGlowShadowPool: FC<{ className?: string }> = ({ children, className }) => {
  const isDesktop = useDesktopMediaQuery()
  if (!isDesktop) return <>{children}</>

  return (
    <div className={classNames(className, 'relative w-full max-w-2xl poolAddCard')}>
      <div className={classNames('')} />
      <div
        style={{
          background:
            'linear-gradient(#171616 0 0) padding-box,linear-gradient(135deg, #f9560a 0%, #ffb800 18%, #52a414 36%, #00aabd 54%, #224e8f 72%, #722378 89%, #c4074d 100%) border-box',
          border: '2px solid transparent',
          borderRadius: '10px',
        }}
        className="relative filter z-10 bg-[#171616] border_r"
      >
        {children}
      </div>
    </div>
  )
}

export default DoubleGlowShadowPool
